const KORTEX_STORAGE_GATE_BASE = "https://web.loykortex.com/api/storage/gate";

function resolveLinkValue(value) {
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (/^[0-9a-f-]{20,}$/i.test(trimmed)) {
      return `${KORTEX_STORAGE_GATE_BASE}/${trimmed}`;
    }
    return null;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const resolved = resolveLinkValue(item);
      if (resolved) return resolved;
    }
    return null;
  }

  if (!value || typeof value !== "object") return null;

  for (const key of [
    "url",
    "href",
    "link",
    "download_url",
    "downloadUrl",
    "signed_url",
    "signedUrl",
    "path",
  ]) {
    const resolved = resolveLinkValue(value[key]);
    if (resolved) return resolved;
  }

  return null;
}

export function resolveKortexDocumentLink(document) {
  if (!document || typeof document !== "object") return null;

  const fromLink = resolveLinkValue(document.link);
  if (fromLink) return fromLink;

  if (typeof document.uid === "string" && document.uid.trim()) {
    return `${KORTEX_STORAGE_GATE_BASE}/${document.uid.trim()}`;
  }

  return null;
}
